module.exports = __webpack_public_path__ + "img/Y-combinator.1a11adb6.png";